// @ts-nocheck
import usePreviousExisting from "@store/Framework/Common/Hooks/usePreviousExisting";
import { DataViewResult } from "@store/Framework/Store/Data/DataState";

export type PersistentDataViewResult = DataViewResult & { _isPersistent?: boolean };

// Cannot efficiently type the dataView property because there is no base type for it and the signatures vary most of the time
const usePersistentDataView = <T>(dataView: T): T => {
    const _dataView = dataView as unknown as PersistentDataViewResult;

    if (_dataView._isPersistent) {
        return dataView;
    }

    const previousValue = usePreviousExisting(_dataView.value);
    const previousPagination = usePreviousExisting(_dataView.pagination);

    return {
        ..._dataView,
        value: _dataView.value || previousValue,
        pagination: _dataView.pagination || previousPagination,
        _isPersistent: true,
    } as any;
};

export default usePersistentDataView;
